import React, { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import io from 'socket.io-client';
import './Chatroom.css';

// Replace the URL with your backend server URL
const socket = io('https://justgotrugged.onrender.com', { transports: ['websocket', 'polling'] });

const Chatroom = () => {
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    // Handle socket connection
    socket.on('connect', () => {
      console.log('Connected to socket:', socket.id);
    });

    // Handle incoming messages
    socket.on('receiveMessage', (data) => {
      console.log('Message received:', data.message); // Debug incoming messages
      setMessages((prevMessages) => [...prevMessages, data.message]);
    });

    // Log connection errors
    socket.on('connect_error', (err) => {
      console.error('Connection Error:', err.message);
    });

    // Cleanup socket connection
    return () => {
      socket.disconnect();
    };
  }, []);

  const sendMessage = () => {
    if (message.trim().length > 200) {
      alert('Message is too long! Please keep it under 200 characters.');
      return;
    }
    if (message.trim()) {
      console.log('Sending message:', message); // Debug outgoing messages
      socket.emit('sendMessage', { message }); // Send message to backend
      setMessages((prevMessages) => [...prevMessages, `You: ${message}`]); // Add your message locally
      setMessage(''); // Clear the input field
    }
  };

  return (
    <Draggable>
      <div className="chatroom">
        <div className="chatroom-header">monkey-chat</div>
        <div className="chatroom-messages">
          {messages.map((msg, index) => (
            <div key={index} className="chatroom-message">
              {msg}
            </div>
          ))}
        </div>
        <div className="chatroom-input">
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type a message..."
          />
          <button onClick={sendMessage}>Send</button>
        </div>
      </div>
    </Draggable>
  );
};

export default Chatroom;
